import React, { useState } from "react";
import { Info, X } from "lucide-react";

export const DemoBanner = () => {
  const [show, setShow] = useState(() => sessionStorage.getItem("wth_demo_dismissed") !== "1");
  if (!show) return null;
  return (
    <div className="bg-slate-950 text-white text-sm" data-testid="demo-banner">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 flex items-center justify-center gap-3 text-center">
        <Info className="w-4 h-4 text-brand shrink-0" />
        <span><strong>Demo inventory</strong> — flights, hotels &amp; holidays shown are realistic samples for preview. Payments (Stripe test) &amp; emails are real. Live supplier availability connects at launch.</span>
        <button onClick={() => { sessionStorage.setItem("wth_demo_dismissed", "1"); setShow(false); }} className="ml-2 text-white/60 hover:text-white" aria-label="Dismiss demo notice"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
